document.documentElement.classList.add('js');

function pad(n) {
  return String(n).padStart(2, '0');
}

function parseEndTime(raw) {
  if (!raw) return NaN;
  var t = new Date(raw).getTime();
  return isNaN(t) ? NaN : t;
}

function getCountdownGroups() {
  var groups = [].slice.call(document.querySelectorAll('[data-usci-hero-count]'));
  var legacy = document.getElementById('heroCount');
  if (legacy && groups.indexOf(legacy) === -1) groups.push(legacy);
  var finalCount = document.getElementById('finalCount');
  if (finalCount) groups.push(finalCount);
  return groups;
}

function getEndForCountdownEl(el) {
  var hero = el.closest('[data-usci-cyber-hero]');
  if (hero) {
    var heroEnd = parseEndTime(hero.getAttribute('data-usci-cyber-end'));
    if (!isNaN(heroEnd)) return heroEnd;
  }
  var ownEnd = parseEndTime(el.getAttribute('data-usci-cyber-end'));
  if (!isNaN(ownEnd)) return ownEnd;
  return parseEndTime('2026-10-31T23:59:59');
}

var groups = getCountdownGroups();

function tick() {
  groups.forEach(function (g) {
    if (!g) return;
    var end = getEndForCountdownEl(g);
    var d = end - Date.now();
    if (d < 0) d = 0;
    var D = Math.floor(d / 864e5);
    var H = Math.floor((d % 864e5) / 36e5);
    var M = Math.floor((d % 36e5) / 6e4);
    var S = Math.floor((d % 6e4) / 1e3);
    var dayEl = g.querySelector('[data-d]');
    var hourEl = g.querySelector('[data-h]');
    var minEl = g.querySelector('[data-m]');
    var secEl = g.querySelector('[data-s]');
    if (dayEl) dayEl.textContent = pad(D);
    if (hourEl) hourEl.textContent = pad(H);
    if (minEl) minEl.textContent = pad(M);
    if (secEl) secEl.textContent = pad(S);
  });
}

if (groups.length) {
  tick();
  setInterval(tick, 1000);
}

var revs = [].slice.call(document.querySelectorAll('.reveal'));
if ('IntersectionObserver' in window) {
  var io = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  revs.forEach(function (el) {
    io.observe(el);
  });
} else {
  revs.forEach(function (el) {
    el.classList.add('in');
  });
}
setTimeout(function () {
  revs.forEach(function (el) {
    el.classList.add('in');
  });
}, 1600);

function cu(el) {
  var to = parseFloat(el.getAttribute('data-to'));
  var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
  var suf = el.getAttribute('data-suf') || '';
  var s = null;
  function step(t) {
    if (!s) s = t;
    var p = Math.min((t - s) / 1100, 1);
    el.textContent = (to * p).toFixed(dec) + suf;
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

var cups = [].slice.call(document.querySelectorAll('.cup'));
if ('IntersectionObserver' in window) {
  var io2 = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          cu(e.target);
          io2.unobserve(e.target);
        }
      });
    },
    { threshold: 0.6 }
  );
  cups.forEach(function (el) {
    io2.observe(el);
  });
} else {
  cups.forEach(function (el) {
    el.textContent = el.getAttribute('data-to') + (el.getAttribute('data-suf') || '');
  });
}

var qs = [].slice.call(document.querySelectorAll('.faq details'));
qs.forEach(function (d) {
  d.addEventListener('toggle', function () {
    if (d.open) {
      qs.forEach(function (o) {
        if (o !== d) o.open = false;
      });
    }
  });
});

function initUsciOfferRoot(root) {
  var ind = root.querySelector('[data-usci-seat-ind]');
  var team = root.querySelector('[data-usci-seat-team]');
  var note = root.querySelector('[data-usci-seat-note]');
  var cardI = root.querySelector('[data-usci-card-individual]');
  var cardT = root.querySelector('[data-usci-card-team]');

  if (ind && team && note && cardI && cardT) {
    var noteIndividual = root.getAttribute('data-seat-note-individual') || '';
    var noteTeam = root.getAttribute('data-seat-note-team') || '';

    function setSeat(isTeam) {
      team.setAttribute('aria-pressed', isTeam ? 'true' : 'false');
      ind.setAttribute('aria-pressed', isTeam ? 'false' : 'true');
      cardI.hidden = isTeam;
      cardT.hidden = !isTeam;
      note.textContent = isTeam ? noteTeam : noteIndividual;
    }

    ind.addEventListener('click', function () {
      setSeat(false);
    });
    team.addEventListener('click', function () {
      setSeat(true);
    });

    if (root.getAttribute('data-usci-open-team') === 'true') {
      setSeat(true);
    }
  }

  var checkoutBtn = root.querySelector('[data-usci-checkout-btn]');
  if (checkoutBtn && checkoutBtn.getAttribute('href') === '#') {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
    });
  }
}

function initUsciOfferLegacy() {
  var ind = document.getElementById('seatInd');
  var team = document.getElementById('seatTeam');
  var note = document.getElementById('seatNote');
  var cardI = document.getElementById('cardIndividual');
  var cardT = document.getElementById('cardTeam');

  if (ind && team && note && cardI && cardT) {
    function setSeat(isTeam) {
      team.setAttribute('aria-pressed', isTeam);
      ind.setAttribute('aria-pressed', !isTeam);
      cardI.hidden = isTeam;
      cardT.hidden = !isTeam;
      note.textContent = isTeam
        ? '5 or more seats are quoted on headcount — send us your numbers and we’ll price it.'
        : 'One seat, full year, all 7 courses — $163.';
    }
    ind.addEventListener('click', function () {
      setSeat(false);
    });
    team.addEventListener('click', function () {
      setSeat(true);
    });
  }

  var checkoutBtn = document.getElementById('checkoutBtn');
  if (checkoutBtn && checkoutBtn.getAttribute('href') === '#') {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      this.textContent = 'Connect to Shopify checkout to finish →';
    });
  }

  var qf = document.getElementById('quoteForm');
  if (qf && !qf.closest('[data-usci-shopify-contact]')) {
    qf.addEventListener('submit', function (e) {
      e.preventDefault();
      var seats = document.getElementById('qSeats');
      var email = document.getElementById('qEmail');
      var comp = document.getElementById('qCompany');
      if (!seats.value || parseInt(seats.value, 10) < 5) {
        seats.focus();
        return;
      }
      if (!comp.value.trim()) {
        comp.focus();
        return;
      }
      if (!email.value || email.value.indexOf('@') < 1) {
        email.focus();
        return;
      }
      var wrap = document.getElementById('qFormWrap');
      var done = document.getElementById('qDone');
      if (wrap) wrap.style.display = 'none';
      if (done) done.classList.add('show');
    });
  }
}

[].slice.call(document.querySelectorAll('[data-usci-offer-root]')).forEach(initUsciOfferRoot);
if (!document.querySelector('[data-usci-offer-root]')) {
  initUsciOfferLegacy();
}

var COURSES = {
  phish: {
    t: 'Phishing & Social Engineering Awareness Training',
    p: '$49.99',
    d: 'Spot and report phishing, pretexting and social engineering before anyone clicks.',
    m: [
      ['Understanding Phishing & Social Engineering', 'What phishing is · social engineering at work · why employees are targeted · business risks'],
      ['Recognizing Manipulation Tactics', 'Urgency & fear messaging · authority & impersonation scams · trust & curiosity triggers · verification strategies'],
      ['Email, Link, Attachment & QR Threats', 'Suspicious senders & domains · fake links & credential theft · malicious attachments · QR-code phishing'],
      ['Phone, Text, MFA & Collaboration Scams', 'SMS & phone scams · MFA-fatigue abuse · attacks via Teams, Slack & mobile apps'],
      ['Safe Response, Reporting & Habits', 'Password & MFA best practice · data-protection procedures · incident response · reporting suspicious activity']
    ]
  },
  biz: {
    t: 'Cybersecurity for Business & Management',
    p: '$99.99',
    d: 'Governance-level cybersecurity for managers — NIST CSF 2.0, risk and SEC-ready disclosure.',
    m: [
      ['Strategy & Executive Accountability', 'NIST CSF 2.0 · RACI & operating models · risk appetite & policy · SEC-ready disclosure governance'],
      ['Accountability & Risk Assessment', 'Threat landscape & FAIR-Lite loss modeling · frameworks crosswalk · US state & sector rules · audit readiness'],
      ['Risk Management & Technical Controls', 'Identity & access governance · data protection · cloud guardrails · Zero Trust'],
      ['Software Security & Incident Response', 'NIST SP 800-218 secure SDLC · app-sec pipeline · detection engineering · tabletop exercises'],
      ['Third-Party Risk & Planning', 'Vendor risk & contracts · board dashboards · budget & staffing · roadmaps']
    ]
  },
  comp: {
    t: 'Data Privacy & Cybersecurity Compliance',
    p: '$59.99',
    d: 'How privacy and security obligations fit together, and what defensible compliance looks like.',
    m: [
      ['The Legal & Regulatory Universe', 'Federal frameworks · the state-law patchwork · sectoral standards · global & GDPR overlap'],
      ['Threat Landscape & “Reasonable Security”', 'Mapping compliance to threats · what counts as reasonable security · incident response · board accountability'],
      ['Privacy by Design & Security by Default', 'Integrating privacy & security · technology toolkits · data lifecycle · security culture'],
      ['Future Trends: AI, Automation & Regulation', 'Toward a federal privacy law · AI/ML risks · automated-decision-making governance · enforcement outlook'],
      ['Strategic Roadmap & Continuous Compliance', 'Risk-based roadmap · third-party oversight · testing & audit readiness · capstone simulation']
    ]
  },
  gdpr: {
    t: 'Data Privacy & Governance: GDPR, CCPA & Data Ethics',
    p: '$69.99',
    d: 'Comply with GDPR, CCPA/CPRA and emerging state laws — governance, ethics and risk.',
    m: [
      ['The U.S. Privacy Landscape', 'Overview of the U.S. data-privacy system, federal laws & agencies, state laws and governance frameworks'],
      ['CCPA, CPRA & the State-Law Revolution', "California's CCPA & CPRA, state-law innovation beyond California, and how the laws compare"],
      ['GDPR Core Principles & Global Reach', "GDPR's seven principles, who must comply, enforcement, and the principles in practice"],
      ['Comparing U.S. & Global Frameworks', 'Human-rights vs. consumer-protection models, data-subject rights, multinational compliance'],
      ['Privacy & Risk Assessments', 'Why assessments matter, identifying & mitigating risk, documentation & stakeholders'],
      ['Data Ethics & Responsible Use', 'The five core principles of data ethics and embedding them in culture'],
      ['AI, Bias & Automation Risks', 'Algorithmic bias, bias-mitigation cycle, and human oversight of AI systems'],
      ['Ethical Governance Programs', 'Leadership commitment, ethics councils, ethics audits and sustaining the culture'],
      ['Operationalizing Privacy', 'Privacy by design, the PbD lifecycle, vendor oversight and routine workflows'],
      ['Emerging Trends in Privacy Law & Tech', 'Federal & state developments, global reforms, and AI/IoT/blockchain challenges']
    ]
  },
  eng: {
    t: 'Privacy Engineering & Data Anonymization',
    p: '$69.99',
    d: 'Design privacy into systems — anonymization, minimization and de-identification.',
    m: [
      ['Privacy Engineering Basics', 'Core concepts · data-protection principles · re-identification risk · privacy by design'],
      ['USA Privacy Laws', 'HIPAA health-data rules · FTC enforcement · state duties · sensitive-data requirements'],
      ['Anonymization Methods', 'De-identification · data masking · tokenization · aggregation controls'],
      ['Modern Privacy Tools', 'Differential privacy · synthetic data · federated learning · data clean rooms'],
      ['AI Privacy Risks', 'Training-data exposure · model memorization · prompt-leakage controls · AI governance'],
      ['Privacy Governance Framework', 'Data inventory · privacy risk assessment · vendor controls · ethical data use']
    ]
  },
  cust: {
    t: 'Customer Data Privacy & Consent Management',
    p: '$59.99',
    d: 'Handle customer data lawfully — consent, tracking, DSARs and AI governance.',
    m: [
      ['Customer Data Privacy in the U.S.', 'Data & AI-data types · U.S. laws & FTC enforcement · customer rights · transparency & minimization'],
      ['Consent, Choice & Digital Trust', 'Opt-in/opt-out consent · do-not-sell/share · Global Privacy Control · dark patterns'],
      ['Cookies, Pixels & Tracking Risk', 'Cookies, pixels, SDKs & tags · adtech data flows · server-side tracking · pixel-claim failures'],
      ['AI, Personalization & Sensitive Data', 'Customer data in AI systems · AI consent & secondary use · sensitive data · AI governance'],
      ['Building a Privacy-Ready Consent Program', 'CMP & consent logs · consent signals across systems · DSARs, retention & vendors · audit trails']
    ]
  },
  breach: {
    t: 'Data Breach Response & Incident Management',
    p: '$99.99',
    d: 'Respond to, contain and report a breach under SEC, CIRCIA and HIPAA timelines.',
    m: [
      ['Breach Reality & Response Readiness', 'Breach vs. incident basics · reportable data types · cyber resilience · NIST, CIS & Zero Trust'],
      ['Modern Breach Scenarios & Attack Paths', 'Unpatched systems & zero-days · ransomware & extortion · AI phishing & deepfakes · cloud/SaaS/API/vendor'],
      ['U.S. Breach Laws & Reporting Duties', 'Breach law & jurisdiction · HIPAA, GLBA, FTC, FCC, FERPA · SEC materiality · CIRCIA & ransom reporting'],
      ['First 24 Hours of Incident Response', 'Triage & escalation · containment & evidence · notification triggers · recovery & monitoring'],
      ['Crisis Communication, Governance & Resilience', 'Customer notice & media · board, legal, CISO & insurer roles · lessons from major breaches · tabletop & metrics']
    ]
  }
};

function modulesFromCard(card) {
  var modEl = card.querySelector('.usci-course-modules');
  if (!modEl || !modEl.textContent.trim()) return [];
  try {
    var parsed = JSON.parse(modEl.textContent);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function initUsciCourseModal(root, ui) {
  var ov = ui.ov;
  var mT = ui.mT;
  var mD = ui.mD;
  var mM = ui.mM;
  var mBody = ui.mBody;
  var mClose = ui.mClose;
  if (!ov || !mT || !mD || !mM || !mClose) return;

  function openCourseFromCard(card) {
    if (!card) return;
    var id = card.getAttribute('data-course');
    var title = card.getAttribute('data-modal-title') || '';
    var desc = card.getAttribute('data-modal-desc') || '';
    var modules = modulesFromCard(card);
    var c = id ? COURSES[id] : null;

    if (!title && c) title = c.t;
    if (!desc && c) desc = c.d;
    if (!modules.length && c) {
      modules = c.m.map(function (x) {
        return x[0];
      });
    }
    if (!title) return;

    mT.textContent = title;
    mD.textContent = desc;
    mM.innerHTML = modules
      .map(function (modTitle) {
        return '<li>' + modTitle + '</li>';
      })
      .join('');
    if (mBody) mBody.scrollTop = 0;
    ov.classList.add('open');
    ov.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    mClose.focus();
  }

  function openCourse(id) {
    var card = root.querySelector('.course[data-course="' + id + '"]');
    if (card) {
      openCourseFromCard(card);
      return;
    }
    var c = COURSES[id];
    if (!c) return;
    mT.textContent = c.t;
    mD.textContent = c.d;
    mM.innerHTML = c.m
      .map(function (x) {
        return '<li>' + x[0] + '</li>';
      })
      .join('');
    if (mBody) mBody.scrollTop = 0;
    ov.classList.add('open');
    ov.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    mClose.focus();
  }

  function closeCourse() {
    ov.classList.remove('open');
    ov.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  [].slice.call(root.querySelectorAll('.course')).forEach(function (card) {
    card.addEventListener('click', function () {
      openCourseFromCard(card);
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openCourseFromCard(card);
      }
    });
  });

  mClose.addEventListener('click', closeCourse);
  ov.addEventListener('click', function (e) {
    if (e.target === ov) closeCourse();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ov.classList.contains('open')) closeCourse();
  });

  root._usciOpenCourse = openCourse;
}

var legacyOv = document.getElementById('ov');
if (legacyOv) {
  var legacyRoot = legacyOv.closest('[id^="shopify-section-"]') || document;
  initUsciCourseModal(legacyRoot, {
    ov: legacyOv,
    mT: document.getElementById('mTitle'),
    mD: document.getElementById('mDesc'),
    mM: document.getElementById('mMods'),
    mBody: legacyOv.querySelector('.modal .mbody'),
    mClose: document.getElementById('mClose')
  });
}

[].slice.call(document.querySelectorAll('[data-usci-course-root]')).forEach(function (root) {
  var ov = root.querySelector('[data-usci-course-overlay]');
  if (!ov) return;
  initUsciCourseModal(root, {
    ov: ov,
    mT: root.querySelector('[data-usci-modal-title]'),
    mD: root.querySelector('[data-usci-modal-desc]'),
    mM: root.querySelector('[data-usci-modal-mods]'),
    mBody: root.querySelector('[data-usci-modal-body]'),
    mClose: root.querySelector('[data-usci-modal-close]')
  });
});

function updateOfferBar(root) {
  var offerHero = document.querySelector('[data-usci-cyber-hero]');
  var endRaw =
    root.getAttribute('data-usci-offer-end') ||
    (offerHero && offerHero.getAttribute('data-usci-cyber-end')) ||
    '2026-10-31T23:59:59';
  var startRaw = root.getAttribute('data-usci-offer-start') || '2026-10-01T00:00:00';
  var END = parseEndTime(endRaw);
  var START = parseEndTime(startRaw);
  if (isNaN(END)) END = parseEndTime('2026-10-31T23:59:59');
  if (isNaN(START)) START = parseEndTime('2026-10-01T00:00:00');

  var obFill = root.querySelector('[data-usci-obar-fill]') || document.getElementById('obarFill');
  var obLab = root.querySelector('[data-usci-obar-lab]') || document.getElementById('obarLab');
  if (!obFill && !obLab) return;

  var now = Date.now();
  var total = END - START;
  var left = Math.max(0, END - now);
  var pct = total > 0 ? Math.max(0, Math.min(100, (left / total) * 100)) : 0;
  if (obFill) obFill.style.width = pct.toFixed(1) + '%';

  var days = Math.ceil(left / 864e5);
  var endedLabel = root.getAttribute('data-offer-ended-label') || 'October offer has ended';
  var daysPrefix = root.getAttribute('data-offer-days-prefix') || 'October offer \u2014 ';
  var daysSuffix = root.getAttribute('data-offer-days-suffix') || ' left';
  if (obLab) {
    obLab.textContent =
      left <= 0
        ? endedLabel
        : daysPrefix + days + ' day' + (days === 1 ? '' : 's') + daysSuffix;
  }
}

function obarTick() {
  var roots = [].slice.call(document.querySelectorAll('[data-usci-offer-root]'));
  if (roots.length) {
    roots.forEach(updateOfferBar);
    return;
  }
  updateOfferBar(document.documentElement);
}

obarTick();
setInterval(obarTick, 60000);

var mbar = document.getElementById('mbar');
var enrollSec = document.getElementById('enroll');

function mbarCheck() {
  if (!mbar) return;
  var h = document.documentElement.scrollHeight - window.innerHeight;
  var past = window.scrollY / (h || 1) > 0.25;
  var overlap = false;
  if (enrollSec) {
    var r = enrollSec.getBoundingClientRect();
    overlap = r.top < window.innerHeight && r.bottom > 0;
  }
  var show = past && !overlap;
  mbar.classList.toggle('show', show);
  document.documentElement.classList.toggle('mbar-on', show);
}

window.addEventListener('scroll', mbarCheck, { passive: true });
window.addEventListener('resize', mbarCheck);
mbarCheck();
